module.exports = __webpack_public_path__ + "static/media/majales.31920a33.svg";